export class MessageModel {
    public type: 'success' | 'info' | 'warning' | 'error' | 'blank' | string;
    public title: string;
    public content: string;
}
